import React from "react";

const TermsComponent = () => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "1440px",
        minHeight: "100vh",
        background: "linear-gradient(172.67deg, #fffbf9 5.7%, #f7ece3 60.35%)",
        display: "flex",
        flexDirection: "column",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          padding: "30px 60px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            marginBottom: "24px",
            color: "#333",
          }}
        >
          Terms of Use
        </h1>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          1. Terms
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          By accessing this Website, accessible from{" "}
          <a
            href="http://cred-tech.org"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            http://cred-tech.org
          </a>
          , you are agreeing to be bound by these Website Terms and Conditions
          of Use and agree that you are responsible for the agreement with any
          applicable local laws. If you disagree with any of these terms, you
          are prohibited from accessing this site. The materials contained in
          this Website are protected by copyright and trade mark law.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          2. Use License
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          Permission is granted to temporarily download one copy of the
          materials on CredTech Knowledge Federation's Website for personal,
          non-commercial transitory viewing only. This is the grant of a
          license, not a transfer of title, and under this license you may not:
        </p>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "24px",
            marginBottom: "24px",
            color: "#555",
          }}
        >
          <li style={{ marginBottom: "12px" }}>
            modify or copy the materials;
          </li>
          <li style={{ marginBottom: "12px" }}>
            use the materials for any commercial purpose or for any public
            display;
          </li>
          <li style={{ marginBottom: "12px" }}>
            attempt to reverse engineer any software contained on CredTech
            Knowledge Federation's Website;
          </li>
          <li style={{ marginBottom: "12px" }}>
            remove any copyright or other proprietary notations from the
            materials; or
          </li>
          <li style={{ marginBottom: "12px" }}>
            transferring the materials to another person or "mirror" the
            materials on any other server.
          </li>
        </ul>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          This will let CredTech Knowledge Federation to terminate upon
          violations of any of these restrictions. Upon termination, your
          viewing right will also be terminated and you should destroy any
          downloaded materials in your possession whether it is printed or
          electronic format.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          3. Disclaimer
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          All the materials on CredTech Knowledge Federation's Website are
          provided "as is". CredTech Knowledge Federation makes no warranties,
          may it be expressed or implied, therefore negates all other
          warranties. Furthermore, CredTech Knowledge Federation does not make
          any representations concerning the accuracy or reliability of the use
          of the materials on its Website or otherwise relating to such
          materials or any sites linked to this Website.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          4. Limitations
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          CredTech Knowledge Federation or its suppliers will not be hold
          accountable for any damages that will arise with the use or inability
          to use the materials on CredTech Knowledge Federation's Website, even
          if CredTech Knowledge Federation or an authorize representative of
          this Website has been notified, orally or written, of the possibility
          of such damage. Some jurisdiction does not allow limitations on
          implied warranties or limitations of liability for incidental damages,
          these limitations may not apply to you.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          5. Revisions and Errata
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          The materials appearing on CredTech Knowledge Federation's Website may
          include technical, typographical, or photographic errors. CredTech
          Knowledge Federation will not promise that any of the materials in
          this Website are accurate, complete, or current. CredTech Knowledge
          Federation may change the materials contained on its Website at any
          time without notice. CredTech Knowledge Federation does not make any
          commitment to update the materials.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          6. Links
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          CredTech Knowledge Federation has not reviewed all of the sites linked
          to its Website and is not responsible for the contents of any such
          linked site. The presence of any link does not imply endorsement by
          CredTech Knowledge Federation of the site. The use of any linked
          website is at the user's own risk.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          7. Site Terms of Use Modifications
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          CredTech Knowledge Federation may revise these Terms of Use for its
          Website at any time without prior notice. By using this Website, you
          are agreeing to be bound by the current version of these Terms and
          Conditions of Use.
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          8. Your Privacy
        </h2>
        <p style={{ marginBottom: "24px", lineHeight: "1.6", color: "#555" }}>
          Please read our{" "}
          <a
            href="/privacy-policy"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            Privacy Policy
          </a>
          .
        </p>

        <h2
          style={{
            fontSize: "24px",
            fontWeight: "600",
            marginTop: "32px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          9. Governing Law
        </h2>
        <p style={{ lineHeight: "1.6", color: "#555" }}>
          Any claim related to CredTech Knowledge Federation's Website shall be
          governed by the laws of India in without regards to its conflict of
          law provisions.
        </p>
      </div>
    </div>
  );
};

export default TermsComponent;
